import { useCallback, useEffect, useState } from "react";
import { Citation } from "src/taskpane/helpers/Models";
import { CitationContainer } from "../citation-container";
import debounce from "lodash.debounce";
import { useQueryClient } from "@tanstack/react-query";
import levenshtein from "string-comparison";
import { analytics } from "../../index";

export const LoggedInInfoMessage = () => {
  return (
    <div className="flex flex-col items-center w-full px-5 pt-10">
      After adding some text in the Word editor, highlight citations using the 'Find Citations'button.
      <br />
      <br />
      Then select a citation to interact with it.
    </div>
  );
};

export const SelectedCitation = () => {
  const [selectedCitation, setSelectedCitation] = useState<Citation | null>(null);
  const [lastText, setLastText] = useState("");
  const queryClient = useQueryClient();

  const handler = useCallback(
    debounce(async () => {
      try {
        Word.run(async (context) => {
          const currentSelection = context?.document?.getSelection();
          const documentText = context.document.body;
          context.load(currentSelection);
          context.load(documentText, "text");
          await context.sync();
          const distance = levenshtein.levenshtein.distance(documentText.text, lastText);
          if (distance > 10) {
            // If the text has changed significantly, invalidate the existing citations
            queryClient.invalidateQueries({
              queryKey: ["existing-citations"],
            });
            analytics.track("Text pasted, getting citations");
          }
          setLastText(documentText.text);

          const parentContentControl = currentSelection?.parentContentControl;
          if (!parentContentControl) {
            return;
          }
          parentContentControl.load("tag");
          await context.sync();
          const citation = JSON.parse(parentContentControl?.tag) as Citation;
          try {
            if (citation.text) await Office.addin.showAsTaskpane();
          } catch (error) {
            console.error("showAsTaskpane Error", error);
          }
          if (selectedCitation?.opinion_id !== citation?.opinion_id) setSelectedCitation(citation);
        });
      } catch (error) {
        console.error("Error in SelectedCitation -- DocumentSelectionChanged", error);
      }
    }, 300),
    [selectedCitation, lastText, setLastText, queryClient, setSelectedCitation]
  );

  useEffect(() => {
    Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, handler);

    return () => {
      Office.context.document.removeHandlerAsync(Office.EventType.DocumentSelectionChanged, handler);
    };
  }, [handler]);

  return selectedCitation ? <CitationContainer citation={selectedCitation} /> : <LoggedInInfoMessage />;
};
